<template>
<div class="col-md-9">
     <p class="form-control-static unselect" :id="'static-' + id"><slot></slot> <a @click="openItem"><i v-if="openLink != undefined && show" class="glyphicon glyphicon-share"/></a></p>
</div>
</template>

<script>
export default {
  name: "StaticInput",
  data() {
    return {
    };
  },
  props: ["id", "openLink", "openLinkGet", "show"],
  methods: {
	  openItem() {
		  axios
	        .post(this.openLinkGet, {
	          value: this.id
	        })
	        .then(response => {
	        	if(response.data.status == true) {
	        		console.log(this.openLink + response.data.id + "/")
	        		this.$router.push({path: this.openLink + response.data.id + "/"})
	        	}
	        }).catch(error => {

			 });
	  }
  }
  
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/StaticInput.vue